import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  Alert,
  AlertDescription,
  Flex,
  ButtonGroup,
  Button,
} from '@frontend/legacy-components';

import { isAccountingAccessible as getIsAccountingAccessible } from 'modules/settings/permissions';

const LearnMore = (props) => (
  <Button
    as="a"
    variant="link"
    target="_blank"
    href="https://help.paperlessparts.com/article/384-accepting-credit-cards-in-paperless-parts"
    {...props}
  >
    Learn More
  </Button>
);

const Message = ({ isAccountingAccessible }) => (
  <AlertDescription fontSize="lg">
    {isAccountingAccessible ? (
      <>
        To avoid delays in credit card payouts, please update your payout
        locations settings.
      </>
    ) : (
      <>
        To avoid delayed credit card payouts, tell your account administrator to
        update your shop&apos;s payout locations settings.
        <LearnMore ml={1} />
      </>
    )}
  </AlertDescription>
);

const StripeBanner = () => {
  const history = useHistory();
  const isAccountingAccessible = useSelector(getIsAccountingAccessible);

  return (
    <Alert
      zIndex="11"
      minH="10"
      border="none"
      as={Flex}
      justifyContent="space-between"
    >
      <Message isAccountingAccessible={isAccountingAccessible} />
      {isAccountingAccessible && (
        <ButtonGroup size="md">
          <LearnMore />
          <Button
            variant="primary"
            onClick={() =>
              history.push('/settings/accounting/banking_information')
            }
          >
            Update Payout Locations
          </Button>
        </ButtonGroup>
      )}
    </Alert>
  );
};

export default StripeBanner;
